import React from "react";
import { ShieldCheck, Star, HeartHandshake, Sparkles } from "lucide-react";

const items = [
  { icon: HeartHandshake, label: "Founder-led support" },
  { icon: Star, label: "Backed by Google Reviews" },
  { icon: ShieldCheck, label: "Trusted by real entrepreneurs" },
  { icon: Sparkles, label: "Guidance beyond registration" },
];

export const TrustStrip = () => (
  <section className="marquee bg-white border-y border-[#EAEAEA] overflow-hidden" data-testid="trust-strip">
    <div className="marquee-track flex items-center gap-14 py-5">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center gap-14 pr-14">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={`${k}-${i}`} className="inline-flex items-center gap-3 text-[13px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
                <span className="w-8 h-8 rounded-full bg-[#FFF9E6] flex items-center justify-center">
                  <Icon size={14} className="text-[#0F1115]" />
                </span>
                {it.label}
                <span className="w-1.5 h-1.5 rounded-full bg-[#FDD805]" />
              </div>
            );
          })}
        </div>
      ))}
    </div>
  </section>
);

export default TrustStrip;
